
import {  GetConsultantByConsultantID, UpdateConsultant, UpdateConsultantBondFile, UpdateConsultantLOGO } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation } from "react-router-dom";
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import LoadingSpinner from "../helpers/loadingspinner";
function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
const EditMultipleConsultant = () => {
    let query = useQuery();
    var consultantID = query.get("consultantID");
  const [isDisabled, setIsDisabled] = useState(false);
  const [isempedit, setempEdit] = useState(null);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState(null);
  const [imgfilepath, setimgFilepath] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [fileURL, setFileURL] = useState();
  const [isLoading, setIsLoading] = useState(false)
  const token = localStorage.getItem('jwtToken');
  function handleChange(event) {
    setFile(event.target.files[0])
    setFileName(event.target.files[0].name)
    var fileInput = document.getElementById('bondFile');

    var filePath = fileInput.value;

    // Allowing file type
    var allowedExtensions =
      /(\.pdf|\.doc|\.docx)$/i;

    if (!allowedExtensions.exec(filePath)) {
      Swal.fire({
        text: 'Invalid File Type!',
      })
      // toast.error('Issue with data format', {autoClose:500})

      fileInput.value = '';
      return false;
    }
    else {

      return true;
    }
  }
 
  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    setPhotoURL(file)
    setimgFilepath(URL.createObjectURL(file));
    var fileInput =document.getElementById('consultantLOGO');
var filePath = fileInput.value;
         
// Allowing file type
var allowedExtensions =
        /(\.jpg|\.jpeg|\.png)$/i;
 
if (!allowedExtensions.exec(filePath)) {
  Swal.fire({
    text: 'Invalid File Type!',
      })
   // toast.error('Issue with data format', {autoClose:500})
   
    fileInput.value = '';
    setimgFilepath("");
    
    return false;
}
else
{ 
  setimgFilepath(URL.createObjectURL(event.target.files[0]));
  return true;
} 
  
  }
  const onSubmit = (data, e) => {
    e.preventDefault();

UpdateData(data)
UpdateConsultantLogo(data)
if(file!=null){
UpdateTermsandConditions(data)
}

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }
  const UpdateData = async(data) => {
    
    const loggedInUser = localStorage.getItem("tokenid");
       const filterData= {
      "ConsultantID":consultantID,
      "UserID":loggedInUser,
      "ConsultantName":data.consultantName,
      "ConsultantMail":data.consultantMail,
      "ConsultantURL":data.consultantURL,
      "ConsultantContactNumber":data.consultantContactNumber
    }

   const apiUrl = UpdateConsultant.APIURL;

const response = await Axios.put(
  apiUrl,
  filterData,
  {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
)

      .then((result) => {
        if (result.data.message === " Record upadted successfully") {
          GetConsultantProfile();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Updated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
              }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something went Wrong',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }


      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  const UpdateConsultantLogo = async(data) => {
    
    const loggedInUser = localStorage.getItem("tokenid");
    const formData = new FormData();    
    formData.append('ConsultantID', consultantID);
    formData.append("ConsultantLOGO", data.consultantLOGO);
   formData.append("ConsultantLOGOurl",photoURL?photoURL:imgfilepath);
      formData.append('UserID', loggedInUser);
 

    apiUrl = UpdateConsultantLOGO.APIURL;
    Axios.put(apiUrl, formData, {
  headers: {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "multipart/form-data"  // because you're sending formData
  }
})

      .then((result) => {
        if (result.data.message === " Record upadted successfully") {
          // GetConsultantProfile();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Updated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
              }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something went Wrong',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }


      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  const UpdateTermsandConditions = async(data) => {
    
    const loggedInUser = localStorage.getItem("tokenid");
    const formData = new FormData();    
    formData.append('ConsultantID', consultantID);
    formData.append('BondFile', data.bondFile);
    formData.append('BondFileUrl', file?file:fileURL);
      formData.append('UserID', loggedInUser);

    apiUrl = UpdateConsultantBondFile.APIURL;
   Axios.put(apiUrl, formData, {
  headers: {
    "Authorization": `Bearer ${token}`,
    "Content-Type": "multipart/form-data"  // because you're sending formData
  }
})
      .then((result) => {
        if (result.data.message === " Record upadted successfully") {
          // GetConsultantProfile();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Updated Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
              }
        else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something went Wrong',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Issue with data format', {autoClose:5000})
        }


      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  useEffect(() => {
    GetConsultantProfile();
  }, []);


  const GetConsultantProfile = () => {
    setIsLoading(true)
    const GetapiUrl = GetConsultantByConsultantID.APIURL;
    const fliterdata = {
      "consultantID": consultantID

    };
    Axios.post(GetapiUrl, fliterdata, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })
      .then((result) => {
        setIsLoading(false)
        setValue("consultantName", result.data.consultantName)
        setValue("consultantMail", result.data.consultantMail)
        setValue("consultantURL", result.data.consultantURL)
        setValue("consultantContactNumber", result.data.consultantContactNumber)
        setValue("bondFile", result.data.bondFile)
        setFileName(result.data.bondFile)
        setValue("fileUrl", result.data.bondFileUrl)
        setFileURL(result.data.bondFileUrl)
        setValue("consultantLOGO", result.data.consultantLOGO)
        setValue("consultantLOGOurl", result.data.consultantLOGOurl)
        // setimgFilepath(result.data.consultantLOGOurl)

        const str = result.data.consultantLOGOurl;
const lastFour = str.slice(-4);
if(lastFour=="blob"){
  setimgFilepath(defaultimg)
}
else{
  setimgFilepath(result.data.consultantLOGOurl)
}
        setValue('consultantID', result.data.consultantID)
        if (result.data.message == " Result having some issue  ") {
          setempEdit(null);
        }
        else {
          setempEdit("true");
        }
      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  return (
    <ConsultantLayout>
    <section>
    {isLoading ? <center><LoadingSpinner /></center> :

      <div className="container mt-4 pb-5">

        {/* <h2 style={{color:"#00a7ac",textAlign:"center"}}>
         Edit Profile
        </h2> */}
         <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <h2 className="" style={{color:"#00a7ac"}} >Edit Consultancy Profile</h2>
      </div>
           
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3 ' >
            <div style={{float:"right"}}>
            <OverlayTrigger placement="bottom"  overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Profile</Tooltip>)}> 
            <Link to="/Employer/Profile"> <button className="btn btn-primary mr-3"  btn-ype="button"><i class="fa fa-plus"></i></button>
            </Link>
           </OverlayTrigger>
        </div>
           </div>
           </div>
<hr/>
        <form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <input
                placeholder='ConsultantID'
                type="hidden"
                name="subConsultantID"

                {...register("subConsultantID")}
                

              />
   <div className="col-2">
      
      <div className="upload-btn-wrapper text-center"> 
     
<label htmlFor="consultantLOGO" style={{ cursor: 'pointer' }}>
    <img    src={imgfilepath?imgfilepath:photoURL}
alt="Upload Image" style={{cursor:"pointer",  borderRadius: '50%',
        width: '100px',
        height: '100px',}} />
    <input
      type="file"
      id="consultantLOGO"
      style={{ display: 'none' }}
      {...register('consultantLOGO', { onChange: handleImageUpload })}
    />
  </label>
        

      </div>

</div>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Name</Tooltip>)}>
                <input type="text" name="consultantName" {...register("consultantName", { required: "Consultant Name required" })} placeholder="Consultant Name" className={`form-control basic-form ${errors.consultantName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.consultantName?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Email</Tooltip>)}>
                <input type="consultantMail" name="consultantMail" {...register("consultantMail", { required: "Consultant Mail required" })} placeholder="Consultant Mail  " className={`form-control basic-form ${errors.consultantMail ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.consultantMail?.message}</div>
         
         </div>
         <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>terms & conditions</Tooltip>)}>
              <input {...register("bondFile")}  style={{height:38}}name="bondFile" id="bondFile" type="file" className={`form-control`} accept=".doc, .docx,.pdf" onChange={handleChange} />
</OverlayTrigger>
{fileName && <div style={{fontSize : 13}}> {fileName}</div>}
<br />
<a href={fileURL} target="_blank"><p>click here to Download File</p></a>

<div className="invalid-feedback">{errors.bondFile?.message}</div>
</div>
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="Number"
                  min="0"
                  title=''
                  name="consultantContactNumber"
                  disabled={isDisabled}
                  {...register("consultantContactNumber", { required: "Mobile Number Required" })}
                  className={`form-control basic-form ${errors.consultantContactNumber ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.consultantContactNumber?.message}</div>
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>webiste url</Tooltip>)}>
                <input type="text" title="" name="consultantURL" {...register("consultantURL", { required: "website URL required" })} placeholder="Consultant URL " className={`form-control basic-form ${errors.consultantURL ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.consultantURL?.message}</div>
         </div>
           </div>

          </div>
         
    
          <div className="row mt-4 p-0">
            <div className="col-12">
             
            <Link to="/Employer/Dashboard">  <button  style={{float:"right"}}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                Cancel
              </button>
              </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Save
              </button> &nbsp;&nbsp;&nbsp;
            </div>


          </div>

        </form>
              </div>

      }
    </section>
  </ConsultantLayout>
  );
}

export default EditMultipleConsultant;